<template>
    <div class="index">
        <div class="index_left">
            <!--<leftTree @leftTreeJumpRouter="leftTreeJumpRouter"></leftTree>-->
            <leftTree></leftTree>
        </div>
        <div class="index_right">
            <Header @jumpRouter="jumpRouter"></Header>
            <div class="index_routerView">
                <div :class="{'active':componentsItemLabel==item.label}" v-for="item in componentsArray" :key="item.label">
                    <component :is="item.name" :parentToChild="item.query"></component>
                </div>
                <!--<component is="componentsItemLabel"></component>-->
            </div>
        </div>
    </div>
</template>

<script>
    import {reactive, computed, ref} from 'vue'
    import leftTree from '@/components/Index/LeftTree.vue'
    import Header from '@/components/Index/Header'
    import Home from './Home/Home.vue'
    import Hotline from './EventManage/Hotline.vue'
    import Jsjb from './EventManage/Jsjb.vue'
    import Jsjb_handInput from './EventManage/Jsjb_handInput.vue'
    import TotallAnalysis from '@/views/TotallAnalysis/TotallAnalysis'
    import CheckCondition from '@/views/CheckCondition.vue'
    import TimelineAll from '@/components/EventManage/Jsjb/TimeLineAll.vue'
    import RunMap from './RunMap/RunMap.vue'
    import StatisticalAnalysis from './SignIn/StatisticalAnalysis.vue'
    import ViewStatisticalAnalysis from '@/components/SignIn/ViewStatisticalAnalysis.vue'
    import AddressBook from '@/views/AddressBook/AddressBook.vue'//通讯录
    import FileDownload from '@/views/FileDownload/FileDownload.vue'//通讯录
    import GridOverview from '@/views/StatisticAnalysis/GridOverview.vue'//网格概览
    import UndertakingAnalysis from '@/views/StatisticAnalysis/UndertakingAnalysis.vue'//承办分析
    import Cbdwkh from '@/views/Jxkh/Cbdwkh.vue'//承办单位考核
    import Wgykh from '@/views/Jxkh/Wgykh.vue'//网格员考核
    import {useRouter} from 'vue-router'
    import {useStore} from 'vuex'

    export default {
        name: 'Index',
        components: {
            leftTree,
            Header,
            Home,
            Hotline,
            Jsjb,
            Jsjb_handInput,
            TotallAnalysis,
            CheckCondition,
            TimelineAll,
            RunMap,
            StatisticalAnalysis,
            ViewStatisticalAnalysis,
            AddressBook,
            FileDownload,
            GridOverview,
            UndertakingAnalysis,
            Cbdwkh,
            Wgykh
        },
        setup() {
            // let router = useRouter();
            const store = useStore();
            // let comcomponentsName = ref("Hotline")
            // comcomponentsName.value = store.state.headerActiveTab
            let componentsItemLabel =computed(() => {
                return store.state.headerActiveTab;
            })
            // const comcomponentsArray = store.state.leftTreeToHeaderTab;
            const componentsArray=computed(() => {
                return store.state.leftTreeToHeaderTab;
            })
            // console.log(comcomponentsArray)
            // router.push({
            //     path:"/Home",
            // })
            const jumpRouter = (param) => {
                componentsItemLabel.value = param.label;
            }
            // const leftTreeJumpRouter = (param) => {
            //     componentsItemLalbel.value = param;
            // }
            return {
                jumpRouter,
                componentsArray,
                componentsItemLabel,
                // leftTreeJumpRouter,
            }
        }
    }
</script>
<style lang="less">
    .index {
        width: 100%;
        height: 100%;
        display: flex;
        .index_right {
            flex: 1;
            overflow: hidden;
            background-color: #E8ECFF;
            .index_routerView {
                height: calc(100% - 48px);
                overflow: auto;
                & > div {
                    height: 100%;
                    display: none;
                    position: relative;
                }
                & > div.active {
                    display: block;
                    height: 100%;
                }
            }
        }

    }
</style>
